import React, { useState } from 'react';
import { MessageCircle, X, Phone } from 'lucide-react';

const FloatingWhatsApp = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const openWhatsApp = () => {
    const message = `Hi Shunmugavel! 👋

I'm interested in your consulting services and would like to discuss:

• Six Sigma Implementation & Training
• ISO Certification (9001:2015, 42001 AIMS, 27001 ISMS)
• AI Management Systems & RPA
• Process Excellence & Operational Optimization
• Risk Management & Quality Audits

Could we schedule a consultation call to discuss my requirements?

Looking forward to hearing from you!

Best regards`;
    
    const whatsappUrl = `https://wa.me/919962536379?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setIsExpanded(false);
  };

  const directCall = () => {
    window.location.href = 'tel:+919962536379';
    setIsExpanded(false);
  };

  const toggleExpanded = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="floating-whatsapp fixed bottom-20 right-6 z-[9999]">
      {/* Expanded Menu */}
      {isExpanded && (
        <div className="mb-4 bg-gray-900 border border-turquoise-500/30 rounded-lg p-4 shadow-2xl min-w-[280px] z-[10001]" style={{ position: 'relative', zIndex: 10001 }}>
          <div className="flex items-center justify-between mb-3">
            <h4 className="heading-3 turquoise-text">Quick Connect</h4>
            <button 
              onClick={() => setIsExpanded(false)}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <X size={16} />
            </button>
          </div>
          
          <div className="space-y-3">
            <button
              onClick={openWhatsApp}
              className="w-full flex items-center gap-3 p-3 bg-green-600 hover:bg-green-500 transition-colors rounded-none text-white"
            >
              <MessageCircle size={20} />
              <div className="text-left">
                <div className="font-medium">WhatsApp Chat</div>
                <div className="text-sm opacity-90">Instant consultation</div>
              </div>
            </button>
            
            <button
              onClick={directCall}
              className="w-full flex items-center gap-3 p-3 bg-turquoise-600 hover:bg-turquoise-500 transition-colors rounded-none text-black"
            >
              <Phone size={20} />
              <div className="text-left">
                <div className="font-medium">Direct Call</div>
                <div className="text-sm opacity-90">+91 9962536379</div>
              </div>
            </button>
          </div>
          
          <div className="mt-3 pt-3 border-t border-gray-700">
            <p className="text-xs text-gray-400 text-center">
              Available: Mon-Fri, 9 AM - 6 PM IST
            </p>
          </div>
        </div>
      )}

      {/* Main Floating Button */}
      <button
        onClick={toggleExpanded}
        className={`relative w-16 h-16 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 z-[10000] cursor-pointer ${
          isExpanded 
            ? 'bg-turquoise-600 text-black rotate-180' 
            : 'bg-green-600 text-white hover:bg-green-500 hover:scale-110'
        }`}
        title="Contact via WhatsApp"
        style={{ 
          position: 'relative', 
          zIndex: 10000,
          border: 'none',
          outline: 'none',
          pointerEvents: 'auto'
        }}
      >
        {isExpanded ? <X size={26} /> : <MessageCircle size={26} />}
        
        {/* Pulse Animation */}
        {!isExpanded && (
          <div className="absolute inset-0 rounded-full bg-green-600 animate-ping opacity-30 pointer-events-none"></div>
        )}
      </button>
    </div>
  );
};

export default FloatingWhatsApp;